import React from 'react';

export type CircleRightArrowIconProps = React.SVGProps<SVGSVGElement>;

export default function CircleRightArrowIcon(props: CircleRightArrowIconProps) {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
      <g clipPath="url(#clip0_2308_61618)">
        <path d="M14.7787 11.3331L11.2027 7.75712L12.1454 6.81445L17.3307 11.9998L12.1454 17.1851L11.2027 16.2425L14.7787 12.6665H6.66406V11.3331H14.7787Z" fill="currentColor" />
      </g>
      <rect x="0.5" y="0.5" width="23" height="23" rx="11.5" stroke="currentColor" />
      <defs>
        <clipPath id="clip0_2308_61618">
          <rect width="16" height="16" fill="transparent" transform="translate(4 4)" />
        </clipPath>
      </defs>
    </svg>
  );
}
